/**
 * Created by rkotha on 8/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators'];
    	$stateProvider
        .state('siteadminreports', {
            parent: 'reports',
            url: '/siteadminreports',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracCustomerReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/site-admin-reports/site-admin-reports.html',
                    controller: 'SiteAdminReportsMainController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracCustomerReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                siteAdminEntity: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'piwik'}).$promise;
                }]
            }
        });

    }
})();
